import React from "react";
import { useTranslation } from "react-i18next";
import Grid2 from "@mui/material/Unstable_Grid2";
import { MainLayout } from "../../layout/mainLayout";
import { LoadingIndicator } from "../../framework/loadingIndicatorNew";
import { VehicleReportFilters } from "../VehicleReportFilters";
import { ReportSection } from "../ReportSection";
import { useDriverLogData } from "../../../hooks/reporting/useDriverLogData";
import { DriverLogGrid } from "./DriverLogGrid";

export const DriverLogMain = () => {
    const { t } = useTranslation();
    const {
        loading,
        rows,
        vehicles,
        vehicleGroups,
        employees,
        costCenters,
        customers,
        filterByVehicles,
        filterByEmployees,
        filterByCostCenters,
        filterByCustomers,
    } = useDriverLogData();

    return (
        <MainLayout noContainer className="fluid">
            <Grid2 container rowSpacing={2} pt={1}>
                <ReportSection
                    id="driver-log-filters"
                    header={t("reporting.filters")}
                    subsections={[
                        {
                            id: "filters",
                            content: (
                                <VehicleReportFilters
                                    vehicles={vehicles}
                                    vehicleGroups={vehicleGroups}
                                    employees={employees}
                                    costCenters={costCenters}
                                    customers={customers}
                                    requireVehicleSelection
                                />
                            ),
                        },
                    ]}
                />

                <LoadingIndicator loading={loading} />
                {!loading && (
                    <DriverLogGrid
                        rows={rows}
                        vehicles={vehicles}
                        employees={employees}
                        costCenters={costCenters}
                        customers={customers}
                        filterByVehicles={filterByVehicles}
                        filterByEmployees={filterByEmployees}
                        filterByCostCenters={filterByCostCenters}
                        filterByCustomers={filterByCustomers}
                        noRowsText={t("reporting.noDriverLogData")}
                    />
                )}
            </Grid2>
        </MainLayout>
    );
};
